export enum Maturity {
  Baby = 'baby',
  Teen = 'teen',
  Adult = 'adult',
}
